// extracted by mini-css-extract-plugin
export default {"container":"Pager_container__L1WEN","navButton":"Pager_navButton__+bqrq","pageButton":"Pager_pageButton__CzgPC","active":"Pager_active__IT8bs"};